module.exports = __webpack_public_path__ + "img/logo_d_19.46a6e152.png";